//@flow
import { useState } from 'react';
import { fetchData } from './helpers';

export function useMutation(mutation, options = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mutateData = async (variables) => {
    setLoading(true);
    try {
      const body = { query: mutation, variables };
      const { data, errors } = await fetchData(body, options);
      if (errors) {
        setError(errors);
        return { data, errors };
      }
      setLoading(false);
      return { data };
    } catch (err) {
      setLoading(false);
      setError(err);
    }
  };

  return { loading, error, mutate: mutateData };
}
